import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProductDetails from '../../../ProductDetails/index';

export default () => (
  <Switch>
    <Route exact path="/viewproduct" component={ProductDetails} />
  </Switch>
);